import React, { Component } from "react";
import Header from '../../layouts/Header';
import Footer from '../../layouts/Footer';
import { Tutions_Banner } from '../../components/Home/Banner';
import { BASE_URL, MAXDIS_FIL, MAXFEE_FIL, MINDIS_FIL, MINFEE_FIL, FIL_DIS, FIL_FEE, MAXFEE_FILP, MAXDIS_FILP, MAXFEE_FILPlay1, CENTERLAT, CENTERLNG } from '../../constant';
import FetchCall, { getAreaNames, getTutionList, getSchoolListDatas, verifyOTP,tuitionFilter, saveLead, getPhonenumber } from '../../API/FetchCall';
import { Link } from 'react-router-dom';
import { AdsOne, AdsTwo, AdsHorizandal, AdsVertical } from '../../components/others/ads';
import Rating from 'react-star-rating-component';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyA9MtbfG_zlo64B2lqNMvigTBuXHkagKcE");
Geocode.setLanguage("en");
Geocode.setRegion("es");
Geocode.enableDebug();

import { TuitionRight } from '../../components/others/ads_vertical_landing';
import { TopTrending } from '../Banner/topTrending';
import $ from 'jquery';
import {
  Form,
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardText,
  CardFooter
} from "reactstrap";

import Step1Dance from "./Step1Dance";
import Step2Dance from "./Step2Dance";
import Step3Dance from "./Step3Dance";

import styled from "styled-components";
import MultiStepProgressBar from "./MultiStepProgressBar";

class LeadFormDance extends Component {
  constructor(props) {
    super(props);

    // Set the intiial input values
    this.state = {
      currentStep: 1,
      listing:[],
      status:false,
      showForm:true,
      waiting:false,
      iscall:false,
      islisting:false,
      locationerros:false,        
      email: "",
      Lastname: "",
      Firstname: "",
      Mobilenumber:"",
      location:"",
      city:'',
      lat:0,
      lng:0,
      searchkey:"",
      accepttakingcalls:"no",
      lead_vertical: "dance",
      value: '',
      suggestions: [],
      latitude:'',
      longtitude:'',
      localities:[],
      isSuggested:false  
    };
    //$(".invisible-content").hide();
    // Bind the submission to handleChange()
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    // Bind new functions for next and previous
    this._next = this._next.bind(this);
    this._prev = this._prev.bind(this);
  }


  componentDidMount() {

    const { history, location } = this.props;

    let data_auth = (localStorage.getItem("myData"));
    if (data_auth) {
        let auth_data = JSON.parse(data_auth)

        this.setState({
          l_first_name: auth_data.first_name,
          l_last_name: auth_data.last_name,
          l_email_id: auth_data.email_id,
       });

      //get phonenumberr
      this.getPhonenumber(auth_data.user_id);


    }


    if(location.state!=undefined){

      this.setState({ 
          currentStep: location.state.step,
          location: location.state.location,
          latitude: location.state.latitude,
          longtitude: location.state.longtitude,
          isSuggested: location.state.isSuggested,
          city: location.state.city
       });

    }


  }


  getPhonenumber(user_id){

    let userdata = JSON.stringify({
      user_id: user_id     
    })

    getPhonenumber(userdata).then((response) => {
        if (response.status == 1) {
          console.log(response);
          this.setState({email:response.email_id, 
               Lastname:response.last_name,
               Firstname:response.first_name, 
               Mobilenumber:response.phonenumber, 
               mobverified:response.isuserverified
          });
        }
    });

  }

  
  addjquery= () => {
      //alert("fddfdf");
      //var moreLessButton = $(".invisible-content").hasClass('hidden') ? 'Read Less' : 'Read More';
      //$('.btnreadmore').text(moreLessButton);
      $(".large-content").toggleClass('large-content-full');
          
  }

  // Use the submitted data to set the state
  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });

    if(value=='others'){
      this.setState({isothers:true})
    }else{
      this.setState({isothers:false})
    } 

  }

  handleChangeLocation(event) {
    
    const { name, value } = event.target;
    this.setState({
        [name]: value
    });

    Geocode.fromAddress(value).then(
    response => {
          
          this.setState({locationerros:false,lat: response.results[0].geometry.location.lat, lng: response.results[0].geometry.location.lng });

    },error => {
        this.setState({locationerros:true});
    });    
  
  } 

  handleSubmit = (event) => {

      event.preventDefault();

      if(this.state.Firstname==''){
        alert("please enter first name");
        return false;
      }

      if(this.state.Lastname==''){
        alert("please enter last name");
        return false;
      }

      if(this.state.Mobilenumber==''){
        alert("please enter mobile number");
        return false;
      }

      if(this.state.email==''){
        alert("please enter email address");
        return false;
      }

      let toastr = '';
      const { 
          email, 
          Lastname, 
          city,
          Firstname, 
          Mobilenumber, 
          searchkey, 
          location,
          latitude,
          longtitude,         
          lead_classfrequency,
          lead_premisestype,
          lead_dancetype,
          lead_mode,
          accepttakingcalls
       } = this.state;

      let leaddata = JSON.stringify({
        email: email,
        Firstname: Firstname,
        Lastname: Lastname,
        Mobilenumber: Mobilenumber,
        searchkey:searchkey,
        location: location,
        city:city,
        lat:latitude,
        lng:longtitude,         
        lead_vertical: 'dance',
        lead_classfrequency: lead_classfrequency,
        lead_premisestype: lead_premisestype,
        lead_dancetype:lead_dancetype,
        lead_mode: lead_mode,
        accepttakingcalls:accepttakingcalls
      })

      this.setState({showForm:false, waiting:true, status:false});

      saveLead(leaddata).then((response) => {


          if (response.status == 1) {
                      
           if(accepttakingcalls=='listing'){
              this.setState({waiting:false, islisting:true,status:true, listing:response.result})
            }else{
              this.setState({waiting:false, iscall:true, status:true, listing:response.result})
              
              /*  
              toastr = window.toastr.success;
              toastr(response.message, toastr, {
                positionClass: "toast-bottom-center",
                containerId: "toast-bottom-center"
              });
              */

            }
         

          }
      }); 
       
  };

  verifyOTPsent = (event) => {
      
      event.preventDefault();

      $("#Otp").removeClass('invalid').removeClass('valid');

      $("#verifiedstatus").removeClass('greentext').removeClass('redtext');
      $("#verifiedstatus").html('please wait....');

      let leaddata = JSON.stringify({
        mobilenumber: $("#countrycode").val()+$("#Mobilenumber").val(),
        otp: $("#Otp").val(),
      })

      verifyOTP(leaddata).then((response) => {
          if (response.status==1) {
              $("#Otp").addClass('valid');
              this.setState({mobverified:1});
              $("#verifiedstatus").addClass('greentext').html('Success, your mobile number is verified.');
          }
          else if (response.status==2) {
              $("#Otp").addClass('invalid');
              this.setState({mobverified:0});
              $(".sendoptbutton").show().html('Resend OTP');
              $("#verifiedstatus").addClass('redtext').html('OTP is invalid.');
          }
          else{
              $("#verifiedstatus").html('Issue verifying OTP.');
          }
      }); 

  }

  // Trigger an alert on form submission
  handleSubmit2 = event => {
    event.preventDefault();
    const { email, Lastname, Firstname } = this.state;
    alert(`Your registration detail: \n 
      Email: ${email} \n 
      Lastname: ${Lastname} \n
      Firstname: ${Firstname}`);
  };

  // Test current step with ternary
  // _next and _previous functions will be called on button click
  _next() {
    let currentStep = this.state.currentStep;
    
    if(currentStep==1 && this.state.city==''){
      alert("please select city");
      return false;
    }

    if(currentStep==1 && this.state.location==''){
      alert("please enter locality");
      return false;
    } 

    if(currentStep==1 && this.state.locationerros){
      alert("please verify locality you entered is valid");
      return false;
    }
    

    if(currentStep==1 && this.state.searchkey==''){
      alert("please choose type of dance");
      return false;
    }

    let isSuggested = this.state.isSuggested;
    if(!isSuggested){
      alert("Invalid Locality..please choose any one of suggested localities");
      return false;
    }   
        
    // If the current step is 1 or 2, then add one on "next" button click
    currentStep = currentStep >= 2 ? 3 : currentStep + 1;
    this.setState({
      currentStep: currentStep
    });
  }

  _prev() {
    let currentStep = this.state.currentStep;
    // If the current step is 2 or 3, then subtract one on "previous" button click
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep
    });
  }

  // The "next" and "previous" button functions
  get previousButton() {
    let currentStep = this.state.currentStep;

    // If the current step is not 1, then render the "previous" button
    if (currentStep !== 1) {
      return (
        <Button color="secondary btn-sm float-left" onClick={this._prev}>
          Previous
        </Button>
      );
    }

    // ...else return nothing
    return null;
  }

  get nextButton() {
    let currentStep = this.state.currentStep;
    // If the current step is not 3, then render the "next" button
    if (currentStep < 3) {
      return (
        <Button color="primary btn-sm float-right" onClick={this._next}>
          Next
        </Button>
      );
    }
    // ...else render nothing
    return null;
  }

  get submitButton() {
    let currentStep = this.state.currentStep;

    // If the current step is the last step, then render the "submit" button
    if (currentStep > 2) {
      return <Button color="primary btn-sm float-right">Submit</Button>;
    }
    // ...else render nothing
    return null;
  }


  escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }
  onSuggestionsFetchRequested = ({ value }) => {

    const val = this.escapeRegexCharacters(value.trim());
    let fetch = JSON.stringify({
      city: this.state.city,
      keyword:val
    });
    getAreaNames(fetch).then(res => {
      if (res.status == 1) {
        this.setState({
          suggestions: res.list
        });
      }
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, index, method }) => {
      console.log('ping... ', suggestion)

      this.setState({
          latitude: suggestion.latitude,
          longtitude: suggestion.longtitude,
          isSuggested:true
      });


  }

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };
  getSuggestionValue = (suggestion) => {
    return suggestion.name;
  }

  renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  onAutoSuggestChange = (event, { newValue, method }) => {
    this.setState({
      location: newValue,
      isSuggested:false
    });
  };



  render() {

    let topTrending = {
      category_id: 4,
      city: 'bengaluru',
      subcategory: 28,
      subcategory_term: 'dance-and-theatre',
      category_name: 'after-school-activity',
      sub_category: 0
    }

    const {value, suggestions, city, isothers, localities} = this.state;

    const inputPropsD = {
      value: this.state.location,
      onChange: this.onAutoSuggestChange,
      name: 'location',
      className: 'form-control'
    };      

    return (
      <React.Fragment>
        <Header />

        <section class="secound-landing features-area nav nav-tabs new-landing-page" id="nav-tab" role="tablist">
          <div className='container'>
            <div class="row" style={{ padding: 10 }}>

              <div className="mt-3 col-lg-3 col-md-4 pl-md-0 d-none d-md-block">
                  <div className='laning-stick'>
                       <div className="d-none d-md-block">
                        <TopTrending param={topTrending} />
                      </div>

                  </div>
              </div>
              <div className="mt-3 col-lg-8 col-md-8 leadform">
                      {this.state.showForm && !this.state.waiting && !this.state.status && (
                      <div class="formdisplay">
                      <Form onSubmit={this.handleSubmit}>
                        <Card>
                          <CardHeader>Find Dance Centers in your city</CardHeader>
                          <CardBody>
                            <CardTitle>
                              <MultiStepProgressBar currentStep={this.state.currentStep} />
                            </CardTitle>
                            <CardText />
                            <Step1Dance
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}
                              city={this.state.city}  
                              location={this.state.location}  
                              isothers={isothers}
                              suggestions={suggestions}
                              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                              getSuggestionValue={this.getSuggestionValue}
                              renderSuggestion={this.renderSuggestion}
                              onSuggestionSelected={this.onSuggestionSelected}
                              inputPropsD={inputPropsD}
                            />
                            <Step2Dance
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}

                            />
                            <Step3Dance
                              currentStep={this.state.currentStep}
                              handleChange={this.handleChange}
                              verifyOTPsent={this.verifyOTPsent}
                              Firstname={this.state.Firstname}  
                              Lastname={this.state.Lastname}  
                              email={this.state.email}  
                              Mobilenumber ={this.state.Mobilenumber}  
                              isuserverified={this.state.isuserverified}  
                            />
                           
                          </CardBody>
                          <CardFooter>
                            {this.previousButton}
                            {this.nextButton}
                            {this.submitButton}
                          </CardFooter>
                        </Card>
                      </Form>
                      </div>
                      )}
                      {this.state.waiting && !this.state.status && (
                      <div class="waiting">
                        
                            processing...please wait.... 

                      </div>
                       )}
                      
                      {this.state.iscall && !this.state.waiting && this.state.status && (
                      <div class="aftersubmitdisplay fade-in-image">
                      
                      <div class="alert alert-success" role="alert">
                        <h4 class="alert-heading">Well done!</h4>
                        <p>Your information is processed successfully. We will reach you soon</p>
                        <hr/>
                        <p class="mb-0">You have successfully registered @BeWise portal, Please <a href="/email-verification">click here</a> to verify and login.</p>
                      </div>

                                          
                    </div>
                      )}



                   {this.state.listing.length>0 && 
                      <div class="col-lg-12 col-md-12">
                        <div class="alert alert-success" role="alert">
                        <div class="msg_black">
                            <p>Please find list of dance centers as per your selection. <br/> 
                            For your convenience, a mail with Top 5 from this short list has been sent to your mail box. <br/> 
                            (FYI - We are enabling follow through calls to you - from institutions of your choice) <br/> </p>
                          </div>
                        </div>
                      </div>
                  }   

                    {!this.state.waiting && this.state.status && (
                      <div class="listing-lead">
                        
                        <h5>Search results: </h5>

                        {this.state.listing.length>0 && 

                         this.state.listing.map((item, idx) => (   
                      <div class="col-lg-12 col-md-12">

                      <React.Fragment>
                        <div class="row">
                         <div className='col-xs-12 col-md-12'>
                          <div className='row landing-tile'>
                            <div className='col-xs-12 col-lg-12'>
                              <div className='row align-items-center d-flex'>
                                
                                <div className='col-3 pr-0 '>
                                  <div className='tile-img'>
                                    <img src={item.images} />
                                  </div>
                                </div>
                                
                                <div className='col-9'>
                                        <div className='tile-detail-sec tile-title row align-items-center'>
                                         <div className='col-lg-10 p-0'>
                                            <p className='text-wrap'>
                                              <a href={item.partner_link} target="_blank">{item.name}</a>
                                            </p>
                                          </div>
                                          <div className='col-lg-2 p-0 d-none d-md-block'>
                                            <div className='tile-btn-biew pull-right'>
                                              <a href={item.partner_link} target="_blank" className='btn btn-sm btn-primary'>More Info</a>
                                              
                                            </div>
                                          </div>                                          
                                        </div>
                                        <div className='tile-detail-sec tile-adrs row'>
                                          <p className='text-wrap'>{item.address}</p>
                                        </div>
                                        <div className='tile-detail-sec align-items-center row'>

                                        </div>
                                        
                                      </div>
                                
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div> 

                      </React.Fragment>

                      </div>


                          ))
                      
                       }
                      {this.state.listing.length>0 && 
                      <React.Fragment>
                      <div class="row">
                        <span class="endline">If you want to see more listing, please&nbsp;<a href={'/' + this.state.city + '/after-school-activity/dance-and-theatre'}>click here</a></span>
                      </div>
                      </React.Fragment>
                      }

                       {this.state.listing.length==0 &&
                        <div class="listing-lead listing_nodata">Sorry, We have no data found at this time.
                        </div>
                       }



                      </div>


                      )}



                     {this.state.status && (
                      <div class="backoptions">
                            <p><i class="fas fa-info-circle">Click on an option below for any other info</i></p>
                                                      
                            <a href="/best-preschools-near-me" class="btn btn-primary btn-sm">Preschool</a>
                            &nbsp;

                            <a href="/best-sports-classes-near-me" class="btn btn-primary btn-sm">Sports</a>
                            &nbsp;
                            
                             <a href="/best-music-classes-near-me" class="btn btn-primary btn-sm">Music</a>
                            &nbsp;
                            <a href="/best-arts-classes-near-me" class="btn btn-primary btn-sm">Creative Arts</a>
                            &nbsp;
                            <a href="/best-skill-enrichment-classes-near-me" class="btn btn-primary btn-sm">Mind and Skill enrichment</a>
                            &nbsp;
                            <a href="/best-hobby-passion-enriching-classes-near-me" class="btn btn-primary btn-sm">Hobbies and Passion</a>
                            &nbsp;                          
                                                         
                            <a href="/best-tuitions-near-me" class="btn btn-primary btn-sm">Tuitions</a>
                            &nbsp;

                            <a href="/best-dance-classes-near-me" class="btn btn-primary btn-sm"><i class="fas fa-refresh">Reload</i></a>
                            &nbsp;
                      </div>
                      )}

                      <div class="large-content">

                     <div class="visible-content">
                          <h5>How can I find the best dance teacher near me? </h5>
                          <p>In addition to its many benefits for our kid's health and development, dance also plays an important role in their education. The most important thing for children is to move! It's essential to get kids moving (especially in this digital age). To enhance the cognitive development of your kid you can find the best dance teacher near me.</p>
                     </div>   
                     
                     <div class="invisible-content">
                      
<p>Talking about theater practice, and performance in a play develops concentration, which can also be applied to life and school subjects. The ability to express ideas verbally and nonverbally is enhanced through acting. Besides improving voice projection and articulation, it also improves language fluency. </p>

<div><h5>Types of Dance Form</h5>
    <h6>1. Bharatanatyam </h6>
    <p>There are many classical dance traditions in India, but one of the oldest is Bharatanatyam. Dance form Bharatanatyam is the state form of Tamil Nadu. There are different types of banis in Bharatanatyam. A bani, or 'tradition', describes a dance style and technique that is exclusive to a particular guru or school. To enroll your kid, you can find one such class on Google by searching Bharatnatyam Classical Dance Classes Near Me</p>

    <h6>2. Kuchipudi</h6>
    <p>There are five classical styles, but Kuchipudi is the only one that includes singing. It is indigenous to the state of Andhra Pradesh. Sidhyendra Yogi is credited with originating Kuchipudi with the creation of his dance-drama Bhama Kalapam, a story about Satyabhama, Krishna's beautiful yet jealous wife. To enroll your kid, you can find one such class on Google by searching Kuchipudi Classical Dance Classes Near Me</p>


    <h6>3. Odissi</h6>
    <p>An ancient Indian classical dance originating in temples of Odisha, an eastern coastal state, Odissi is also called Orissi in old literature. Through songs written and composed by ancient poets of the state in accordance with the ragas & talas of Odissi music. In addition, Odissi performances have expressed ideas related to Hindu gods and goddesses such as Shiva and Surya. To enroll your kid, you can find one such class on Google by searching Odissi Classical Dance Classes Near Me</p>

    <h6>4. Kathak</h6>
    <p>The Kathak dance form is native to North India and is one of the six classical dance forms of the country. In Hindu temples, Kathak is used to portray epic stories from Hindu scriptures such as Mahabharata and Ramayana. To enroll your kid, you can find one such class on Google by searching Kathak Classical Dance Classes Near Me</p>

    <h6>5. Bollywood</h6>
    <p>Dance forms used in Indian films are called Bollywood - one of the best western dance classes. A variety of styles are incorporated into it. There are many styles of dance, including belly dancing, kathak, Indian folk, Western popular, jazz, and even Western erotic dancing. Bollywood dance in the context of South Asian film both in terms of commercial and artistic considerations. To enroll your kid, you can find one such class on Google by searching Bollywood Dance Classes Near Me</p>

    <h6>6. Salsa and Similar Dance</h6>
    <p>A Latin dance that originated in New York City in the 1960s, salsa is associated with a music genre of the same name. The salsa is a fusion of Cuban and American dances such as mambo, pachanga, and rumba. To enroll your kid, you can find one such class on Google by searching Salsa Western Dance Classes Near Me</p>

    <h6>7. Hip Hop</h6>
    <p>Amongst the best western dance classes, hip-hop dance evolved into a form of street dance and is now being performed in well equipped dance classes. There are elements of African dance, tap, and ballet in it. Originally, hip hop dance was a form of freestyle dancing performed by street dance crews. To enroll your kid, you can find one such class on Google by searching Hip Hop Western Dance Classes Near Me</p>

    <h6>8. Ballet</h6>
    <p>Over 500 years ago, Italians invented ballet dance as an art form. The ballet technique requires strength, balance, technical ability, and flexibility despite the dancer's appearance of gentleness and grace. To enroll your kid, you can find one such class on Google by searching Ballet Western Dance Classes Near Me</p>
   
    </div>                


                     </div>
                     
                     </div> 

                      
              </div>

              <div className="mt-3 col-md-1 pl-md-2 m-hide-ads">
                <div className='laning-stick'>
                  <TuitionRight />
                </div>
              </div>
            </div>
            <AdsHorizandal />
          </div>
        </section>
      <Footer />
      </React.Fragment>
    );
  }
}

export default LeadFormDance;
